import React, { useEffect } from "react";
import { Progress } from "semantic-ui-react";

const PercentageBar = ({ summaryData, listLength }) => {
  const percentage = (summaryData.length / listLength) * 100;
  return (
    <Progress className="summarization-progress"
      percent={percentage}
      indicating
      fluid
      label={`Document loaded ${summaryData.length} of ${listLength}`}
    />
  );
};

export default PercentageBar;
